import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { SnackExtraSettings } from '@/features/snacks/store/types';
import type { SnacksSliceState } from '@/features/snacks/store/types';
import type { Snack } from '@/features/snacks/types/Snack';
import { SNACK_DEFAULT_TIMEOUT } from '@/features/snacks/constants/snackTimeout';

const initialState: SnacksSliceState = {
  snacks: [],
};

export const snacksSlice = createSlice({
  name: 'snacksSlice',
  initialState,
  reducers: {
    addSnack: (
      state,
      {
        payload: { duplicationsAllowed = true, forceClean = false, ...newSnack },
      }: PayloadAction<Snack & SnackExtraSettings>,
    ) => {
      if (forceClean) state.snacks = [];

      const index = state.snacks.findIndex((snack) => snack.content === newSnack.content);

      if (duplicationsAllowed && index !== -1) return;
      state.snacks.push({ timeout: SNACK_DEFAULT_TIMEOUT, closeIcon: true, ...newSnack });
    },
    removeSnack: (state) => {
      if (state.snacks.length) state.snacks.shift();
    },
    removeAllSnacks: (state) => {
      state.snacks = [];
    },
  },
});

export const { addSnack, removeSnack, removeAllSnacks } = snacksSlice.actions;

export const snacksReducerPath = snacksSlice.reducerPath;
export const snacksReducer = snacksSlice.reducer;
